import i18next from "i18next";
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// the translations
const resources = {
  en: {
    translation: `en/outil-interactif/7344233/locales/en/translation.json`,
  },
  fr: {
    translation: `en/outil-interactif/7344233/locales/fr/translation.json`,
  },
  loadPath: `en/outil-interactif/7344233/locales/{{lng}}/translation.json`,
};

i18next
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: resources,
    lng: "en",
    debug: true,
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18next;
